<template>
  <div
    v-if="currentWeather"
    class="widget-wrapper"
    :class="{ vertical: isVertical }"
  >
    <div class="weather-info">
      <p class="weather-info__time">
        {{ currentTimeHours }}:{{ currentTimeMinutes }}
      </p>
      <p class="weather-info__date">
        {{ currentDate }}
      </p>
      <p class="weather-info__weather">
        {{
          firstSymbolToUppercase(currentWeather.current.weather[0].description)
        }}
      </p>
      <div class="weather-indicators">
        <div class="weather-indicator">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 5.16646L11.75 13.4165C10.1185 15.0481 9.00749 17.1269 8.55742 19.39C8.10736 21.6531 8.33847 23.9988 9.22153 26.1305C10.1046 28.2623 11.5999 30.0843 13.5185 31.3662C15.437 32.6481 17.6926 33.3323 20 33.3323C22.3074 33.3323 24.563 32.6481 26.4815 31.3662C28.4001 30.0843 29.8954 28.2623 30.7785 26.1305C31.6615 23.9988 31.8927 21.6531 31.4426 19.39C30.9925 17.1269 29.8815 15.0481 28.25 13.4165L20 5.16646ZM20 0.453125L30.6067 11.0598C32.7044 13.1576 34.133 15.8303 34.7118 18.74C35.2906 21.6498 34.9935 24.6657 33.8582 27.4066C32.7229 30.1475 30.8003 32.4902 28.3335 34.1384C25.8668 35.7866 22.9667 36.6663 20 36.6663C17.0333 36.6663 14.1332 35.7866 11.6665 34.1384C9.19974 32.4902 7.27715 30.1475 6.14183 27.4066C5.00651 24.6657 4.70945 21.6498 5.28821 18.74C5.86698 15.8303 7.29557 13.1576 9.39334 11.0598L20 0.453125Z"
              fill="white"
            />
          </svg>
          <p class="weather-indicator__value">
            {{ currentWeather.current.humidity }}
            <span>%</span>
          </p>
        </div>
        <div class="weather-indicator">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 28.3333H6.66665V25H17.5C18.5646 25.0003 19.6087 25.292 20.5194 25.8435C21.43 26.3949 22.1724 27.185 22.6661 28.1282C23.1598 29.0714 23.3859 30.1317 23.3201 31.1942C23.2542 32.2568 22.8988 33.281 22.2924 34.156C21.686 35.031 20.8517 35.7234 19.88 36.1581C18.9082 36.5928 17.836 36.7533 16.7795 36.6222C15.723 36.4911 14.7226 36.0734 13.8865 35.4143C13.0505 34.7553 12.4108 33.88 12.0366 32.8833L15.1583 31.7116C15.3186 32.1388 15.5927 32.514 15.951 32.7964C16.3093 33.0789 16.7381 33.258 17.1908 33.3142C17.6436 33.3705 18.1031 33.3017 18.5196 33.1154C18.9361 32.9292 19.2937 32.6325 19.5536 32.2575C19.8135 31.8825 19.9659 31.4435 19.9941 30.9882C20.0224 30.5328 19.9255 30.0784 19.714 29.6741C19.5024 29.2699 19.1843 28.9312 18.794 28.6949C18.4037 28.4585 17.9562 28.3335 17.5 28.3333ZM8.33331 18.3333H30.8333C31.8979 18.3337 32.9421 18.6254 33.8527 19.1768C34.7634 19.7282 35.5057 20.5183 35.9994 21.4615C36.4931 22.4047 36.7193 23.465 36.6534 24.5275C36.5875 25.5901 36.2321 26.6143 35.6257 27.4893C35.0194 28.3643 34.1851 29.0567 33.2133 29.4914C32.2415 29.9262 31.1693 30.0867 30.1128 29.9556C29.0564 29.8244 28.0559 29.4067 27.2199 28.7477C26.3838 28.0886 25.7441 27.2133 25.37 26.2166L28.4916 25.045C28.6519 25.4721 28.9261 25.8473 29.2844 26.1298C29.6426 26.4123 30.0714 26.5913 30.5242 26.6476C30.9769 26.7038 31.4365 26.6351 31.853 26.4488C32.2695 26.2625 32.627 25.9658 32.8869 25.5908C33.1469 25.2158 33.2992 24.7769 33.3275 24.3215C33.3557 23.8661 33.2588 23.4117 33.0473 23.0074C32.8357 22.6032 32.5176 22.2646 32.1273 22.0282C31.7371 21.7919 31.2896 21.6668 30.8333 21.6666H8.33331C7.00723 21.6666 5.73546 21.1398 4.79778 20.2022C3.8601 19.2645 3.33331 17.9927 3.33331 16.6666C3.33331 15.3405 3.8601 14.0688 4.79778 13.1311C5.73546 12.1934 7.00723 11.6666 8.33331 11.6666H22.5C22.9562 11.6664 23.4037 11.5414 23.794 11.305C24.1843 11.0687 24.5024 10.7301 24.714 10.3258C24.9255 9.92157 25.0224 9.46714 24.9941 9.01176C24.9659 8.55638 24.8135 8.11743 24.5536 7.74244C24.2937 7.36746 23.9361 7.07076 23.5196 6.88448C23.1031 6.69821 22.6436 6.62946 22.1908 6.68569C21.7381 6.74192 21.3093 6.92098 20.951 7.20348C20.5928 7.48597 20.3186 7.86113 20.1583 8.2883L17.0366 7.11829C17.5174 5.83964 18.4316 4.7702 19.6199 4.09631C20.8082 3.42243 22.1952 3.18682 23.5394 3.43054C24.8835 3.67427 26.0995 4.38187 26.9756 5.43006C27.8516 6.47824 28.3321 7.80057 28.3333 9.16663C28.3333 10.7137 27.7187 12.1975 26.6248 13.2914C25.5308 14.3854 24.0471 15 22.5 15H8.33331C7.89129 15 7.46736 15.1756 7.1548 15.4881C6.84224 15.8007 6.66665 16.2246 6.66665 16.6666C6.66665 17.1087 6.84224 17.5326 7.1548 17.8451C7.46736 18.1577 7.89129 18.3333 8.33331 18.3333Z"
              fill="white"
            />
          </svg>
          <p class="weather-indicator__value">
            {{ Math.round(currentWeather.current.wind_speed) }}
            <span>{{ 'infoscreen_weather_wind_speed_unit' | translate }}</span>
          </p>
        </div>
        <div class="weather-indicator">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 3.3335C29.205 3.3335 36.6666 10.7952 36.6666 20.0002C36.6666 29.2052 29.205 36.6668 20 36.6668C10.795 36.6668 3.33331 29.2052 3.33331 20.0002C3.33331 10.7952 10.795 3.3335 20 3.3335ZM20 6.66683C12.6366 6.66683 6.66665 12.6368 6.66665 20.0002C6.66665 27.3635 12.6366 33.3335 20 33.3335C27.3633 33.3335 33.3333 27.3635 33.3333 20.0002C33.3333 12.6368 27.3633 6.66683 20 6.66683ZM20 8.3335C21.6966 8.3335 23.3083 8.69516 24.7633 9.34683L22.1583 11.9502C21.47 11.7668 20.7466 11.6668 20 11.6668C15.3983 11.6668 11.6666 15.3985 11.6666 20.0002C11.6666 22.3002 12.6 24.3835 14.1066 25.8935L11.75 28.2502L11.49 27.9818C9.53331 25.8952 8.33331 23.0868 8.33331 20.0002C8.33331 13.5568 13.5566 8.3335 20 8.3335ZM30.6533 15.2385C31.3033 16.6918 31.6666 18.3052 31.6666 20.0002C31.6666 23.2218 30.36 26.1385 28.25 28.2502L25.8933 25.8935C27.4 24.3835 28.3333 22.3002 28.3333 20.0002C28.3333 19.2535 28.235 18.5302 28.05 17.8418L30.6533 15.2385ZM27.07 10.5718L29.4283 12.9285L23.2216 19.1385C23.295 19.4135 23.3333 19.7018 23.3333 20.0002C23.3333 21.8418 21.8416 23.3335 20 23.3335C18.1583 23.3335 16.6666 21.8418 16.6666 20.0002C16.6666 18.1585 18.1583 16.6668 20 16.6668C20.2983 16.6668 20.5866 16.7052 20.8616 16.7785L27.0716 10.5718H27.07Z"
              fill="white"
            />
          </svg>
          <p class="weather-indicator__value">
            {{ Math.round(currentWeather.current.pressure / 1.333) }}
            <span>{{ 'infoscreen_weather_pressure_unit' | translate }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="weather-sections">
      <div class="weather-section">
        <p class="weather-section__time">
          {{ 'infoscreen_weather_now' | translate }}
        </p>
        <WeatherIcon
          class="weather-section__icon"
          :icon="currentWeather.current.weather[0].icon"
        />
        <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
        <p class="weather-section__degree">
          {{ Math.round(currentWeather.current.temp) }}
        </p>
      </div>

      <div
        v-for="(weather, index) in hourlyWeather"
        :key="index"
        class="weather-section"
      >
        <p class="weather-section__time">
          {{ getTimeByWeather(weather) }}
        </p>
        <WeatherIcon
          class="weather-section__icon"
          :icon="weather.weather[0].icon"
        />
        <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
        <p class="weather-section__degree">{{ Math.round(weather.temp) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getMonthsTranslation, getWeekdaysTranslation } from '@/helpers/utils';
import InfoscreenConfig from '../../config';
import WeatherIcon from './WeatherIcon';

const ONE_HOUR_IN_MS = 3600000;
const WEATHER_FAILED_FETCH_REFETCH_TIMEOUT = 60000;

export default {
  name: 'WeatherWidget',
  components: {
    WeatherIcon,
  },
  data() {
    return {
      currentWeather: null,
      hourlyWeather: null,
      currentTime: null,
      updateTimeTimeout: null,
      updateWeatherTimeout: null,
      updateCurrentDateTimeout: null,
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.activeLanguage;
    },
    currentTimeHours() {
      try {
        return this.currentTime.getHours().toString().padStart(2, '0');
      } catch (e) {
        return '';
      }
    },
    currentTimeMinutes() {
      try {
        return this.currentTime.getMinutes().toString().padStart(2, '0');
      } catch (e) {
        return '';
      }
    },
    currentDate() {
      try {
        const date = this.currentTime;

        const weekdays = getWeekdaysTranslation(
          this.$store.activeLanguageConsts,
        );
        const months = getMonthsTranslation(this.$store.activeLanguageConsts);

        const weekday = date.getDay() !== 0 ? weekdays[date.getDay() - 1] : weekdays[6];
        const month = months[date.getMonth()];

        return `${date.getDate()} ${month} ${date.getFullYear()}, ${weekday}`;
      } catch (e) {
        return '';
      }
    },
    isVertical() {
      return window.innerWidth / window.innerHeight < 1.6;
    },
  },
  created() {
    this.updateWeather();
  },
  destroyed() {
    clearTimeout(this.updateTimeTimeout);
    clearTimeout(this.updateWeatherTimeout);
    clearTimeout(this.updateCurrentDateTimeout);
  },
  methods: {
    updateWeather() {
      const { lat, lon } = this.$store.deviceStartData.office;

      this.getHourlyWeather({ lat, lon })
        .then((response) => {
          if (this.isWeatherUpdated()) {
            this.currentWeather = response;
            this.setCurrentTime();
            this.updateHourlyWeather();

            this.$nextTick(() => {
              this.initUpdateWeatherTimeout(
                this.getMillisecondsToClosestHour(this.currentTime),
              );
            });
          } else {
            this.setCurrentTime();
            this.handleFailUpdateWeather();
          }

          this.$nextTick(() => {
            this.initUpdateTimeTimeout(
              60000 -
                (this.currentTime.getSeconds() * 1000 +
                  this.currentTime.getMilliseconds()),
            );
          });
        })
        .catch(() => this.handleFailUpdateWeather());
    },
    handleFailUpdateWeather() {
      console.warn(`Погода не обновилась`);
      this.updateHourlyWeather();
      this.initUpdateWeatherTimeout(WEATHER_FAILED_FETCH_REFETCH_TIMEOUT);
    },
    updateHourlyWeather() {
      const currentTime = this.getCurrentTimeByOffset(
        this.currentWeather.timezone_offset,
      );

      const index = this.currentWeather.hourly.findIndex((weather) => {
        const hoursTime = this.getCurrentTimeByOffset(
          this.currentWeather.timezone_offset,
          new Date(weather.dt * 1000),
        );
        return hoursTime > currentTime;
      });

      this.hourlyWeather = this.currentWeather.hourly.slice(index, index + 3);
    },
    isWeatherUpdated(updatedTimestamp) {
      return !(
        this.currentWeather &&
        this.currentWeather.current.dt === updatedTimestamp
      );
    },
    getHourlyWeather({ lat, lon }) {
      const url = `https://console.prontoq.ru/weather/data/3.0/onecall?lat=${lat}&lon=${lon}&exclude=daily,alerts,minutely&appid=${InfoscreenConfig.WEATHERMAP_API_KEY}&units=metric&lang=${this.currentLanguage}`;

      return fetch(url)
        .then((response) => response.json())
        .catch((error) => {
          console.error(`Ошибка при обновлении погоды`, error);
          throw new Error('Update weather error');
        });
    },
    setCurrentTime() {
      let d = new Date();
      this.currentTime = this.getCurrentTimeByOffset(
        this.currentWeather.timezone_offset,
      );
    },
    getMillisecondsToClosestHour(date) {
      const currentTime = date.getTime();
      const fullHours = Math.floor(currentTime / 3600000);
      return (fullHours + 1) * 3600000 - currentTime;
    },
    initUpdateTimeTimeout(ms) {
      clearTimeout(this.updateTimeTimeout);

      this.updateTimeTimeout = setTimeout(() => {
        this.setCurrentTime();
        this.initUpdateTimeTimeout();
      }, ms || 60000 - (this.currentTime.getSeconds() * 1000 + this.currentTime.getMilliseconds()));
    },
    initUpdateWeatherTimeout(ms = ONE_HOUR_IN_MS) {
      clearTimeout(this.updateWeatherTimeout);
      console.log(
        `Погода обновится через ${Math.round(ms / 1000 / 60)} минут(ы)`,
      );
      this.updateWeatherTimeout = setTimeout(() => this.updateWeather(), ms);
    },
    getTimeByWeather(weather) {
      const date = this.getCurrentTimeByOffset(
        this.currentWeather.timezone_offset,
        new Date(weather.dt * 1000),
      );

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    firstSymbolToUppercase(str) {
      return str[0].toUpperCase() + str.slice(1);
    },
    getCurrentTimeByOffset(timezoneOffset = 0, date) {
      if (!date) date = new Date();
      const localTime = date.getTime();
      const localOffset = date.getTimezoneOffset() * 60000;
      const utc = localTime + localOffset;
      return new Date(utc + 1000 * timezoneOffset);
    },
  },
};
</script>

<style lang="scss" scoped>
.widget-wrapper {
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding-left: 2.68518519vh;
  color: #ffffff;
}

.widget-wrapper,
.weather-info,
.weather-indicators,
.weather-indicator,
.weather-sections,
.weather-section {
  display: flex;
}

.weather-info,
.weather-section {
  flex-direction: column;
  justify-content: center;
}

.weather-info {
  flex-grow: 1;

  &__time {
    font-weight: 500;
    font-size: 5.92592593vh;
    line-height: 7.7037037vh;
  }

  &__date {
    font-weight: 600;
    font-size: 2.96296296vh;
    margin-top: 0.277777778vh;
    line-height: 4.4077135vh;
  }

  &__weather {
    font-weight: 300;
    font-size: 2.96296296vh;
    margin-bottom: 1.38888889vh;
    line-height: 4.14814815vh;
  }
}

.weather-indicator {
  align-items: center;
  white-space: nowrap;

  svg {
    width: 4.07366667vh;
  }

  &__value {
    font-size: 2.96296296vh;
    margin-left: 0.833333333vh;

    span {
      font-weight: 300;
      opacity: 0.5;
    }
  }

  &:not(:last-child) {
    margin-right: 1.48148148vh;
  }
}

.weather-sections {
  text-align: center;
}

.weather-section {
  align-items: center;
  width: 10.4166667vw;

  &__time {
    font-size: 2.96296296vh;
    font-weight: 300;
  }

  &__icon {
    width: 11vh;
    height: 11vh;
  }

  &__degree {
    font-size: 5.92592593vh;
    font-weight: 500;

    &:after {
      content: '°';
    }
  }

  &:nth-child(2) {
    background: rgba(0, 0, 0, 0.1);
  }

  &:nth-child(3) {
    background: rgba(0, 0, 0, 0.2);
  }

  &:nth-child(4) {
    background: rgba(0, 0, 0, 0.3);
  }
}

.widget-wrapper.vertical {
  padding-left: 2vw;
  .weather-info {
    flex-grow: 1;

    &__time {
      font-weight: 500;
      font-size: 3.33333333vw;
      line-height: 4.33333333vw;
    }

    &__date {
      font-weight: 600;
      font-size: 1.66666667vw;
      margin-top: 0.15625vw;
      line-height: 2.5vw;
    }

    &__weather {
      font-weight: 300;
      font-size: 1.66666667vw;
      margin-bottom: 0.78125vw;
      line-height: 2.33333333vw;
    }
  }

  .weather-indicator {
    svg {
      width: 2.75vw;
    }
    &__value {
      font-size: 1.66666667vw;
      margin-left: 0.208333333vw;
    }
  }

  .weather-section {
    width: 25vh;

    &__time {
      font-size: 1.66666667vw;
    }

    &__icon {
      width: 11vw;
      height: 11vw;
    }

    &__degree {
      font-size: 3.33333333vw;
    }
  }
}
</style>
